import { IonBackButton, IonBadge, IonButtons, IonHeader, IonIcon, IonLabel, IonMenuButton, IonNav, IonPage, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs, IonTitle, IonToolbar } from '@ionic/react'
import { IonReactRouter } from '@ionic/react-router'
import { apps, calendar, chatboxOutline, chatbubbleOutline, heartOutline, informationCircle, map, personCircle, statsChartOutline } from 'ionicons/icons'
import React, { useEffect, useState } from 'react'
import { Redirect, Route } from 'react-router'
import { db } from '../../data/fireConfig'
import { useGetDataRequest } from '../../data/request'
import Contact from './vote/Contact'
import StatistiqueAward from './vote/StatistiqueAward'
import StatistiqueMiss from './vote/StatistiqueMiss'
import VoteAwardView from './vote/VoteAwardView'
import VoteMissView from './vote/VoteMissView'


function VoteAward() {
  const [votesparticipantes]: any[] = useGetDataRequest("awardcandidats", "/awardcandidats")
  const [status, setStatus] = useState({after:false, block:false, during:false, pause:false, vor:false})
  const [userChoice, setUserChoice] = useState<any[]>([])

  useEffect(() => {
    var unsubscribe:any[] = []
    unsubscribe.push(db.collection("statusaward").limit(1)
      .onSnapshot((snap)=>{
        snap.forEach((data)=>{
          setStatus(data.data() as any);
        })
      }))

      unsubscribe.push(db.collection("userawardchoice")
      .onSnapshot((snap)=>{
        var userchoiceSnap: any[] = []
        snap.forEach((data)=>{
          userchoiceSnap.push({id: data.id, ...data.data() as any});
        })
        //console.log(userchoiceSnap)
        setUserChoice(userchoiceSnap)
      }))

    return () => {
      unsubscribe.forEach(unsub => unsub())
    }
  }, [])
  
  return (
        <IonTabs>
          <IonRouterOutlet>
            <Route path="/voteaward/vote">
              <VoteAwardView misses={votesparticipantes} status={status}  votes={userChoice} />
            </Route>
            <Route exact path="/voteaward/stat">
            <StatistiqueAward misses={votesparticipantes} status={status}  votes={userChoice}/>
            </Route>
            <Route exact path="/voteaward/chat" >
              <Contact  />
            </Route>
           <Redirect exact path='/voteaward' to='/voteaward/vote' />
          </IonRouterOutlet>
          <IonTabBar slot="bottom">
            <IonTabButton tab="tab1" href="/voteaward/vote">
              <IonIcon icon={heartOutline} />
            </IonTabButton>

            <IonTabButton tab="tab2" href="/voteaward/stat">
              <IonIcon icon={statsChartOutline} />
            </IonTabButton>

            <IonTabButton tab="tab3" href="/voteaward/chat">
              <IonIcon icon={chatboxOutline} />
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
  )
}

export default VoteAward